import React, { useEffect } from "react";
import ButtonIconOnly from "components/ButtonIconOnly";
import { motion } from "framer-motion";

const Modal = ({ 
  isOpen, 
  onClose, 
  title, 
  children, 
  backgroundClose = true
}) => {
  // Disable scrolling when modal is open
  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
    } else {
      document.body.classList.remove("overflow-hidden");
    }
    return () => document.body.classList.remove("overflow-hidden");
  }, [isOpen]);

  if (!isOpen) return null;

  return (
    <div 
      className="fixed top-0 left-0 w-screen h-screen flex items-center justify-center z-[1000] overflow-y-auto overflow-x-hidden bg-black/60 backdrop-blur-[2px]"
      onClick={backgroundClose ? onClose : undefined} // Click outside to close
    >
      <motion.div 
        className="bg-white rounded-xl w-[749px] max-w-[90%] overflow-y-auto py-10 relative"
        initial={{ opacity: 0, scale: 0.9 }} 
        animate={{ opacity: 1, scale: 1 }} 
        exit={{ opacity: 0, scale: 0.9 }} 
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside
      >
        {/* Header */}
        <div className="flex justify-between items-center mb-6 px-10">
          <h4 className="tw-heading-4 text-[var(--color-gray-800)]">{title}</h4>
          {backgroundClose && <ButtonIconOnly
            id={`${title}-modal-close-button`}
            dataCy={`${title}-modal-close-button`}
            icon="close"
            size={20} 
            type="alt"
            onClick={onClose}
          />}
        </div>

        {/* Dynamic Content */}
        {children}
      </motion.div>
    </div>
  );
};

export default Modal;